<template>
  <div
    class="generalInfoError"
  >
    <icon
      icon="IlustracaoErro"
    />
    <div class="generalInfoError__title">
      Oops, ocorreu um erro
    </div>
    <div class="generalInfoError__text">
      {{ errorText }}
    </div>
    <router-link
      :to="{ name: 'Home' }"
      class="generalInfoError__button"
      color="transparent"
    >
      <p class="generalInfoError__button__text">
        Ir para o início
      </p>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Error',
  computed: {
    ...mapGetters([
      'messageError'
    ]),
    errorText(){
      return this.messageError?.length > 0 ? this.messageError : 'Por favor, tente novamente mais tarde.';
    }
  },
  metaInfo() {
    return {
      title: 'Erro',
    };
  },
};
</script>

<style lang="scss" scoped>
  .generalInfoError {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
    margin: 4rem 0;

    &__title {
      margin-top: 3rem;
      font-size: $text-2xl;
      font-family: Montserrat-Bold, Arial, Helvetica, sans-serif;
      text-align: center;

      @include make-accessible($black, $white, color);
    }

    &__text {
      width: 100%;
      margin-top: 1rem;
      font-size: $text-base;
      font-family: Montserrat-Regular, Arial, Helvetica, sans-serif;
      text-align: center;

      @include make-accessible($black, $white, color);

      @include screen (desktop-up) {
        width: 40%;
      }
    }

    &__button {
      margin-top: 3rem;
      display: flex;
      justify-content: center;
      width: 14rem;
      align-items: center;
      padding: 0.8rem;
      border-radius: $radius-lg;

      @include make-accessible($primary, $tertiary-accessibility, background-color);

      &__text {
        font-weight: $font-bold;
        font-size: $text-sm;

        @include make-accessible($white, $primary-accessibility, color);
      }
    }
  }
</style>
